import { createSlice } from '@reduxjs/toolkit';

const initialDarkMode = localStorage.getItem('darkMode') === 'true';

// Apply dark mode class immediately on module load
if (initialDarkMode) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

const initialState = {
  darkMode: initialDarkMode,
  sidebarOpen: true,
  wishlist: JSON.parse(localStorage.getItem('wishlist')) || [],
  compareList: JSON.parse(localStorage.getItem('compareList')) || [],
  loading: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('darkMode', state.darkMode);
      if (state.darkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
      localStorage.setItem('darkMode', state.darkMode);
      if (state.darkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    addToWishlist: (state, action) => {
      const productId = action.payload;
      if (!state.wishlist.includes(productId)) {
        state.wishlist.push(productId);
        localStorage.setItem('wishlist', JSON.stringify(state.wishlist));
      }
    },
    removeFromWishlist: (state, action) => {
      const productId = action.payload;
      state.wishlist = state.wishlist.filter(id => id !== productId);
      localStorage.setItem('wishlist', JSON.stringify(state.wishlist));
    },
    addToCompare: (state, action) => {
      const productId = action.payload;
      if (!state.compareList.includes(productId) && state.compareList.length < 4) {
        state.compareList.push(productId);
        localStorage.setItem('compareList', JSON.stringify(state.compareList));
      }
    },
    removeFromCompare: (state, action) => {
      const productId = action.payload;
      state.compareList = state.compareList.filter(id => id !== productId);
      localStorage.setItem('compareList', JSON.stringify(state.compareList));
    },
    clearCompare: (state) => {
      state.compareList = [];
      localStorage.setItem('compareList', JSON.stringify(state.compareList));
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  toggleDarkMode,
  setDarkMode,
  toggleSidebar,
  setSidebarOpen,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
  removeFromCompare,
  clearCompare,
  setLoading,
} = uiSlice.actions;

export default uiSlice.reducer;
